import { useEffect, useState } from 'react';
import {
  useLevelUpFeedStore,
  type LevelUpFeedEntry,
} from '../../store/levelUpFeedSlice';
import { STAT_LABELS } from '../../data/stat-labels.config';
import type { ScalarStatKey } from '../../types/buff.types';
import './LevelUpFeed.scss';

const DISMISS_MS = 4500;

function formatDelta(value: number): string {
  const rounded = Number.isInteger(value) ? value : Number(value.toFixed(1));
  return `${rounded > 0 ? '+' : ''}${rounded}`;
}

const LevelUpToast = ({ entry }: { entry: LevelUpFeedEntry }) => {
  const dismiss = useLevelUpFeedStore((s) => s.dismiss);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setExiting(true), DISMISS_MS);
    return () => clearTimeout(timer);
  }, []);

  const lines = Object.entries(entry.stats).filter(([, v]) => v !== 0);

  return (
    <div
      className={`level-up-toast${exiting ? ' level-up-toast--exiting' : ''}`}
      onAnimationEnd={() => {
        if (exiting) {
          dismiss(entry.id);
        }
      }}
    >
      <div className="level-up-toast-title">Niveau {entry.level}</div>
      <ul className="level-up-toast-stats">
        {lines.map(([stat, value]) => (
          <li key={stat}>
            <span className="level-up-toast-delta">
              {formatDelta(value as number)}
            </span>{' '}
            {STAT_LABELS[stat as ScalarStatKey] ?? stat}
          </li>
        ))}
      </ul>
    </div>
  );
};

export const LevelUpFeed = () => {
  const entries = useLevelUpFeedStore((s) => s.entries);
  if (entries.length === 0) {
    return null;
  }
  return (
    <div className="level-up-feed">
      {entries.map((entry) => (
        <LevelUpToast key={entry.id} entry={entry} />
      ))}
    </div>
  );
};
